import React, { useState, useEffect } from 'react';
import { Users } from 'lucide-react';
import { siteContentService } from '../services/api';

function ScientificAdvisors() {
  const [advisors, setAdvisors] = useState([]);

  useEffect(() => {
    const fetchAdvisors = async () => {
      try {
        const response = await siteContentService.get('SCIENTIFIC_ADVISORS');
        if (response.data && response.data.value) {
          const parsed = JSON.parse(response.data.value);
          if (Array.isArray(parsed)) {
            setAdvisors(parsed);
          }
        }
      } catch (error) {
        console.error('Error fetching scientific advisors:', error);
      }
    };
    fetchAdvisors();
  }, []);

  const mappedAdvisors = advisors.map(advisor => ({
    name: advisor.name,
    affiliation: advisor.email,
    expertise: advisor.bio,
  }));

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">مشاوران علمی</h1>
          <p className="text-xl text-blue-100">متخصصان برجسته در حوزه‌های مختلف</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mappedAdvisors.map((advisor, idx) => (
            <div key={idx} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition border-t-4 border-blue-700">
              <div className="flex items-start gap-3 mb-4">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Users className="w-6 h-6 text-blue-700" />
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-gray-900">{advisor.name}</h3>
                  <p className="text-sm text-blue-700">{advisor.affiliation}</p>
                </div>
              </div>
              <p className="text-gray-600 text-sm">{advisor.expertise}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ScientificAdvisors;
